const table = {
  pagination: {
    rowsPerPage: 'Zeilen pro Seite',
    page: 'Seite {{current}}',
    pageOf: 'Seite {{current}} von {{total}}',
    firstPage: 'Erste Seite',
    previousPage: 'Vorherige Seite',
    nextPage: 'Nächste Seite',
    lastPage: 'Letzte Seite',
  },
} as const;

export default table;
